import { render, staticRenderFns } from "./_ServiceProvider.vue?vue&type=template&id=08cb90f0&scoped=true&"
import script from "./_ServiceProvider.vue?vue&type=script&lang=js&"
export * from "./_ServiceProvider.vue?vue&type=script&lang=js&"
import style0 from "./_ServiceProvider.vue?vue&type=style&index=0&id=08cb90f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb90f0",
  null
  
)

export default component.exports